function TrainOverviewController($interval, $filter, gridletService, CommonService, userViewService, trainService, $state, $stateParams, __env) {
  const ctrl = this;
  const env = __env;
  const setSelectedTrain = CommonService.setSelectedTrain;
  const getSelectedTrain = CommonService.getSelectedTrain;
  const setSelectedCar = CommonService.setSelectedCar;
  const tryCatch = CommonService.tryCatch;

  ctrl.$onInit = async () => {
    ctrl.view = 'trains';
    ctrl.hasProfile = env.profile !== 'QR'; // Naming this way to hide project names from HTML
    ctrl.customProfile = env.profile === 'VALE';
    ctrl.hasLinkToCarView = env.profile === 'VALE' || env.profile === 'DEMO';
    ctrl.wideTrains = env.profile === 'VALE' || env.profile === 'DEMO';
    ctrl.customMelco = env.profile === 'MELCO';
    ctrl.hasHighSpeedTrain = env.profile !== 'LU';
    ctrl.customizable = gridletService.getCustomizable();
    ctrl.hasOperatingMode = env.profile === 'LU' || env.profile === 'DEMO';
    ctrl.customTrainInfo = env.operator === 'bakerloo';
    ctrl.hasClockAndMode = env.profile !== 'VALE';

    ctrl.train = getSelectedTrain();
    // When the page is reloaded, instanly make get train request to avoid seeing empty view
    // Poller in main-configuration view will keep updating the train after a few seconds
    if (!ctrl.train) {
      ctrl.consist = $stateParams.consist;
      const train = await fetchTrain(ctrl.consist);
      setSelectedTrain(train);
      ctrl.train = train;
    }

    ctrl.sinceDataReceived = $filter('secondsAgoUTC')(ctrl.train.status.dataReceived);
    ctrl.sinceTrainClock = $filter('secondsAgoUTCUnix')(ctrl.train.status.trainClock);
    ctrl.startDataReceivedRefresher();
  };

  ctrl.$onDestroy = () => {
    $interval.cancel(ctrl.dataReceivedRefreshPromise);
  };

  ctrl.startDataReceivedRefresher = () => {
    ctrl.dataReceivedRefreshPromise = $interval(ctrl.refreshDataReceived, 1000);
  };

  ctrl.refreshDataReceived = () => {
    ctrl.sinceDataReceived = $filter('secondsAgoUTC')(ctrl.train.status.dataReceived);
    ctrl.sinceTrainClock = $filter('secondsAgoUTCUnix')(ctrl.train.status.trainClock);
  };

  const fetchTrain = (consist) => 
    tryCatch(async () => await trainService.get(consist))
    .fold(e => {
        console.error(`Failed to get train: ${e}`);
        return e;
      },
    data => data);

  // Uses old accessTech information which is currently not available
  ctrl.hasNoConnection = () =>
    (ctrl.train && (ctrl.train.accessTech !== 1 && ctrl.train.accessTech !== 2)) ||
    !ctrl.train ||
    ctrl.train.status === 0;

  // Uses old accessTech information which is currently not available
  ctrl.hasMobileConnection = () => ctrl.train && ctrl.train.accessTech === 1 && ctrl.train.status !== 0;

  // Uses old accessTech information which is currently not available
  ctrl.hasWifiConnection = () => ctrl.train && ctrl.train.accessTech === 2 && ctrl.train.status !== 0;

  ctrl.goToCarView = (car) => {
    if (ctrl.hasLinkToCarView) {
      setSelectedCar(car.carNumber);
      $state.go('car', { carNumber: car.carNumber, trainId: ctrl.train.status.trainId });
    }
  };

  ctrl.goBack = () => {
    $state.go(userViewService.getPreviousView());
  };
}

angular
  .module('configuration-management.module')
  .controller('TrainOverviewController', TrainOverviewController);
